import { routes } from "./../index";
import { pathInRoutes, guestRoutes } from "./../../services/utils";

class RedirectIfAuthenticated {
  constructor(store) {
    this.store = store;
  }

  /**
   * Redirects to dashboard if authenticated
   */
  handle(to, from, next) {
    if (
      this.store.getters["auth/authenticated"] &&
      pathInRoutes(guestRoutes(routes), to.name)
    ) {
      return next("/");
    }

    next();
  }
}

export default RedirectIfAuthenticated;
